import { createContext } from 'react';
import { type FieldPath, type FieldValues } from 'react-hook-form';

type FormItemContextValue = {
  id: string;
};

type FormFieldContextValue<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  name: TName;
  forceRequired?: boolean; // ✅ add this
};

const FormItemContext = createContext<FormItemContextValue>({} as FormItemContextValue);
const FormFieldContext = createContext<FormFieldContextValue>({} as FormFieldContextValue);

export { FormFieldContext, FormItemContext };
